var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.modalTag,_vm._b({tag:"component",on:{"cancel":function($event){return _vm.cancel('click')}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true},{key:"body",fn:function(){return [_vm._t("body")]},proxy:true}],null,true)},'component',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }